import { Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import { DialogTitle, FormButton, FormInput, YupShape } from "suregifts-component-lib";
import { AddRecipientModel, EditRecipientModel } from "../../../services/discount";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

export const schema = yup
  .object<YupShape<AddRecipientModel>>({
    name: yup.string().required(),
    email: yup.string().required().email(),
  })
  .required();

type EditStaffModalProps = {
  saveChanges: (model) => void;
  recipient: AddRecipientModel;
  handleClose: () => void;
};
export const EditStaffModal = ({ saveChanges, recipient, handleClose }: EditStaffModalProps) => {
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm<EditRecipientModel>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: recipient.email,
      name: recipient.name,
      phone: recipient.phone,
    },
  });

  return (
    <Dialog open maxWidth="xs" onClose={handleClose}>
      <DialogTitle title="Edit Staff" handleClose={handleClose} />
      <DialogContent>
        <Stack spacing={2}>
          <FormInput label="Full Name" helperText={errors.name?.message} {...register("name")} />
          <FormInput label="Email" helperText={errors.email?.message} {...register("email")} />
          <FormInput label="Phone Number" {...register("phone")} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <FormButton label="Save" fullWidth disabled={!isValid} onClick={handleSubmit(saveChanges)} />
      </DialogActions>
    </Dialog>
  );
};
